<template>
  <div id='app' :style="{height: scrollerHeight, weight:scrollerWeight}">
    <homePage></homePage>
  </div>
</template>

<script>
import homePage from './components/home/homePage'

export default {
  name: 'App',
  data () {
    return {
    }
  },
  components: {
    homePage
  },
  methods: {
  },
  computed: {
    scrollerHeight: function () {
      return window.innerHeight + 'px'
    },
    scrollerWeight: function () {
      return window.innerWeight + 'px'
    }
  }
}
</script>

<style>
html,
body {
  height: 100%;
  width: 100%;
  min-width: 1263px;
  margin: 0px;
  padding: 0px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue